/* A change to an agent's tables, planned a moment after it last changed (so typing a name
   asks once), and made with the plan it was shown: the column editor's and every dialog's. */
import { useEffect, useState } from "react";

import { useApplyChanges, useSpacePlan } from "@/shared/api/spaces";

import type { SpaceChange, SpacePlan } from "@/shared/types";

const PLAN_WAIT_MS = 300;

export function usePlannedChange(agentId: string, changes: SpaceChange[] | null) {
  const [planned, setPlanned] = useState<SpaceChange[] | null>(null);
  useEffect(() => {
    const wait = window.setTimeout(() => setPlanned(changes), PLAN_WAIT_MS);
    return () => window.clearTimeout(wait);
  }, [changes]);
  const plan = useSpacePlan(agentId, planned);
  const apply = useApplyChanges(agentId);
  const ready = !!changes && planned === changes && !!plan.data && !plan.data.blocked && !plan.isFetching;
  const make = (onDone: (plan: SpacePlan) => void) => {
    if (ready && changes && plan.data) apply.mutate({ changes, digest: plan.data.digest }, { onSuccess: onDone });
  };
  return { plan, ready, pending: apply.isPending, make, waiting: planned !== changes };
}
